import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

type TItem = {
  label: string;
  id: string;
  color?: string;
};

@Component({
  selector: 'prlw-graph-radio-group-ui',
  templateUrl: './graph-radio-group.component.html',
  styleUrls: ['./graph-radio-group.component.scss'],
})
export default class GraphRadioGroupComponent implements OnChanges {
  @Input() items: TItem[] = [];
  @Input() currentItem: string | null = null;
  @Input() appearance: 'rounded-border' | 'grey-rect' = 'rounded-border';

  @Output() handleClick = new EventEmitter<TItem>();

  currentIndex = 0;

  ngOnChanges(): void {
    this.currentIndex = this.items.findIndex(
      (item) => item.id === this.currentItem,
    );
  }

  click(index: number) {
    if (index === this.currentIndex) return;
    this.currentIndex = index;
    this.handleClick.emit(this.items[index]);
  }

  getAppearanceClassName() {
    return `${this.appearance}-appearance`;
  }
}
